<template>
  <h1 class="title">Calculator</h1>
  <Form></Form>
</template>

<script>
import Form from "@/components/calculator/Form.vue";

export default {
  name: "Calculator",
  components: {
    Form,
  },
};
</script>
